import React from 'react'

const CartPlaceholder = React.memo(({ inputRef }) => {
    return (
        <div className="self-stretch flex flex-col justify-center items-center mt-3 text-gray-400 h-full">
            <div className="w-96 flex justify-center items-center flex-col gap-8">
                <div className="text-center font-medium w-72 text-xl text-black">
                    {inputRef?.current?.value ? (
                        <>
                            <p>No search results found for</p>
                            <span className="font-medium mx-1 text-blue-500 text-2xl">
                                "{inputRef.current.value}"
                            </span>
                        </>
                    ) : (
                        ' Browse and add titles you want to subscribe to'
                    )}
                </div>
                <div className="self-stretch flex flex-col justify-between w-full gap-7">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center justify-between gap-2">
                            <div className="bg-cyan-600 p-4 rounded-xl"></div>
                            <div className="flex flex-col gap-2">
                                <div className="bg-cyan-600 py-1 rounded-full w-32"></div>
                                <div className="bg-gray-300 py-1 rounded-full w-40"></div>
                            </div>
                        </div>
                        <div className="flex">
                            <div className="bg-cyan-600 py-2 rounded-full w-24"></div>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center justify-between gap-2">
                            <div className="bg-gray-300 p-4 rounded-xl"></div>
                            <div className="flex flex-col gap-2">
                                <div className="bg-gray-300 py-1 rounded-full w-32"></div>
                                <div className="bg-gray-200 py-1 rounded-full w-40"></div>
                            </div>
                        </div>
                        <div className="flex">
                            <div className="bg-gray-300 py-2 rounded-full w-24"></div>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center justify-between gap-2">
                            <div className="bg-gray-200 p-4 rounded-xl"></div>
                            <div className="flex flex-col gap-2">
                                <div className="bg-gray-200 py-1 rounded-full w-32"></div>
                                <div className="bg-gray-100 py-1 rounded-full w-40"></div>
                            </div>
                        </div>
                        <div className="flex">
                            <div className="bg-gray-200 py-2 rounded-full w-24"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default CartPlaceholder
